import { defineMessages } from 'react-intl';

const messages = defineMessages({
  notes: {
    id: 'App.App.ViewBankDeposit.AddBankDepositDocument.DocumentNotes.Notes',
    defaultMessage: 'Document Notes (Optional)',
  },
});

export default messages;
